import axios from "axios";

// The UI is served from the same host as the API, so a relative base URL works
// in every environment. Override with REACT_APP_API_URL for local development
// against a separately running backend.
const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL || '/'
})

API.interceptors.request.use((config) => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    // Applies Authorization header if token is present in
    // session storage
    if (user !== null) {
        config.headers["Authorization"] = 'Bearer ' + user['token'];
    }

    return config
});

export default API;

